import { api } from "../../globalConfig";

const extract_token = "/token_extract";
const project_backend_graph = api.COMMON_URL;

export { extract_token, project_backend_graph };
